<template>
  <div v-if="credits">
    <!-- Casts -->
    <div class="border border-gray-600 my-4" v-if="credits.cast.length">
      <div class="p-3 border-gray-600 border-b">
        <h1 class="font-semibold uppercase">Credits</h1>
      </div>
      <ul>
        <li
          v-for="(cast, index) in filterNoDate(credits.cast)"
          :key="index"
          class="py-3 px-2"
          :class="[cast.border ? ' border-gray-600 border-b' : '']"
        >
          <template v-if="cast.media_type === 'movie'">
            <router-link
              :to="{
                path: '/movies/',
                name: 'MovieDetails',
                params: {
                  id: cast.id
                }
              }"
            >
              -
              {{ cast["original_title"] || cast["original_name"] }}
              <small class="text-gray-600 capitalize">
                ( {{ cast["media_type"] }} )
              </small>
              <span class="text-xs" v-if="cast.character"
                >as {{ cast["character"] }}</span
              >
            </router-link>
          </template>
          <template v-else>
            -
            {{ cast["original_title"] || cast["original_name"] }}
            <small class="text-gray-600 capitalize">
              ( {{ cast["media_type"] }} )
            </small>
            <span class="text-xs" v-if="cast.character"
              >as {{ cast["character"] }}</span
            >
          </template>
        </li>
      </ul>
      <ul>
        <li
          v-for="cast in sortByDate(credits.cast)"
          :key="cast.id"
          class="py-3 px-2"
          :class="[cast.border ? ' border-gray-600 border-b' : '']"
        >
          <template v-if="cast.media_type === 'movie'">
            <router-link
              :to="{
                path: '/movies/',
                name: 'MovieDetails',
                params: {
                  id: cast.id
                }
              }"
            >
              {{ getYear(cast["release_date"] || cast["first_air_date"]) }} -
              {{ cast["original_title"] || cast["original_name"] }}
              <small class="text-gray-600 capitalize">
                ( {{ cast["media_type"] }} )
              </small>
              <span class="text-xs" v-if="cast.character"
                >as {{ cast["character"] }}</span
              >
            </router-link>
          </template>
          <template v-else>
            {{ getYear(cast["release_date"] || cast["first_air_date"]) }} -
            {{ cast["original_title"] || cast["original_name"] }}
            <small class="text-gray-600 capitalize">
              ( {{ cast["media_type"] }} )
            </small>
            <span class="text-xs" v-if="cast.character"
              >as {{ cast["character"] }}</span
            >
          </template>
        </li>
      </ul>
    </div>
    <!-- Crew -->
    <template v-if="credits.crew.length">
      <div
        class="border border-gray-600 my-4"
        v-for="(crew, index) in arrayOfObj(credits.crew)"
        :key="index"
      >
        <div class="p-3 border-gray-600 border-b">
          <h1 class="font-semibold uppercase">{{ crew.department }}</h1>
        </div>
        <ul>
          <li
            v-for="(cast, index) in filterNoDate(crew.collection)"
            :key="index"
            class="py-3 px-2"
            :class="[cast.border ? ' border-gray-600 border-b' : '']"
          >
            <template v-if="cast.media_type === 'movie'">
              <router-link
                :to="{
                  path: '/movies/',
                  name: 'MovieDetails',
                  params: {
                    id: cast.id
                  }
                }"
              >
                -
                {{ cast["original_title"] || cast["original_name"] }}
                <small class="text-gray-600 capitalize">
                  ( {{ cast["media_type"] }} )
                </small>
                <span class="text-xs" v-if="cast.job"
                  >... {{ cast["job"] }}</span
                >
              </router-link>
            </template>
            <template v-else>
              -
              {{ cast["original_title"] || cast["original_name"] }}
              <small class="text-gray-600 capitalize">
                ( {{ cast["media_type"] }} )
              </small>
              <span class="text-xs" v-if="cast.job">... {{ cast["job"] }}</span>
            </template>
          </li>
        </ul>
        <ul>
          <li
            v-for="cast in sortByDate(crew.collection)"
            :key="cast.id"
            class="py-3 px-2"
            :class="[cast.border ? ' border-gray-600 border-b' : '']"
          >
            <template v-if="cast.media_type === 'movie'">
              <router-link
                :to="{
                  path: '/movies/',
                  name: 'MovieDetails',
                  params: {
                    id: cast.id
                  }
                }"
              >
                {{ getYear(cast["release_date"] || cast["first_air_date"]) }} -
                {{ cast["original_title"] || cast["original_name"] }}
                <small class="text-gray-600 capitalize">
                  ( {{ cast["media_type"] }} )
                </small>
                <span class="text-xs" v-if="cast.job"
                  >... {{ cast["job"] }}</span
                >
              </router-link>
            </template>
            <template v-else>
              {{ getYear(cast["release_date"] || cast["first_air_date"]) }} -
              {{ cast["original_title"] || cast["original_name"] }}
              <small class="text-gray-600 capitalize">
                ( {{ cast["media_type"] }} )
              </small>
              <span class="text-xs" v-if="cast.job">... {{ cast["job"] }}</span>
            </template>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import { computed } from "vue";
import moment from "moment";
export default {
  name: "credits",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const credits = computed(() => props.data.combined_credits);
    const getYear = date => moment(date).year();

    const filterNoDate = lists => {
      const filterLists = lists.filter(
        list => !(list["release_date"] || list["first_air_date"])
      );

      return filterLists.map((item, index) => {
        if (index === filterLists.length - 1) {
          item.border = true;
        }
        return item;
      });
    };

    const sortByDate = lists => {
      const sorted = lists
        .filter(list => list["release_date"] || list["first_air_date"])
        .sort((a, b) => {
          let bdate = b["release_date"] || b["first_air_date"];
          let adate = a["release_date"] || a["first_air_date"];

          return moment(bdate) - moment(adate);
        });

      return subDivision(sorted);
    };

    const subDivision = arr => {
      return arr.map((item, index) => {
        let nextDate;
        let currDate =
          arr[index]["release_date"] || arr[index]["first_air_date"];

        if (index < arr.length - 1) {
          nextDate =
            arr[index + 1]["release_date"] || arr[index + 1]["first_air_date"];
        }
        if (getYear(currDate) > getYear(nextDate)) {
          item.border = true;
        }

        return item;
      });
    };

    const arrayOfObj = arr => {
      return arr.reduce((accumulator, current) => {
        let newObj = {};
        let matchDepartment = accumulator.find(
          i => i.department == current.department
        );
        let matchIndex = accumulator.findIndex(
          i => i.department == current.department
        );
        if (matchDepartment) {
          accumulator[matchIndex]["collection"].push(current);
        } else {
          newObj["department"] = current["department"];
          newObj["collection"] = [current];

          accumulator.push(newObj);
        }

        return accumulator;
      }, []);
    };

    return {
      credits,
      getYear,
      sortByDate,
      arrayOfObj,
      filterNoDate
    };
  }
};
</script>

<style></style>
